import { alpha } from "@mui/material"

export const assetRegisterTableStyles = {
    backgroundColor: "background.neutral",
    borderCollapse: "separate",
    borderSpacing: "0 10px",
    borderRadius: 1,
    paddingLeft: "16px",
    paddingRight: "16px",
    "& th": {
        backgroundColor: (theme) => alpha(theme.palette.background.neutral, 0),
    },
}
